export default __webpack_public_path__ + "static/media/Download.247d20a4.svg";